import { render } from "./FormDialog.vue?vue&type=template&id=04a393d5&ts=true"
import script from "./FormDialog.vue?vue&type=script&lang=ts"
export * from "./FormDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__